import { render } from "./index.vue?vue&type=template&id=878af71c&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=tsx"
export * from "./index.vue?vue&type=script&lang=tsx"

import "./index.vue?vue&type=style&index=0&id=878af71c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-878af71c"]])

export default __exports__